module.exports = __webpack_public_path__ + "img/outlook.3255cbb1.svg";